import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-revert-email-change',
  standalone: true,
  templateUrl: './revert-email-change.component.html',
  imports: [FormsModule, CommonModule],
  styleUrls: ['./revert-email-change.component.css'],
})
export class RevertEmailChangeComponent implements OnInit {
  token: string = '';
  loading: boolean = true;
  errorMessage: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'] || '';

      if (this.token) {
        this.processRevertRequest();
      } else {
        this.loading = false;
        this.errorMessage = 'Invalid request. No token provided.';
      }
    });
  }

  processRevertRequest(): void {
    this.http
      .get(`${environment.apiUrl}/users/revert-email-change/${this.token}`, {
        observe: 'response',
        responseType: 'text',
      })
      .subscribe({
        next: (response) => {
          this.authService.logout().subscribe({
            next: () => {
              this.handleRevertResponse(response);
            },
            error: (logoutError) => {
              console.error('Logout error during email revert:', logoutError);
              this.handleRevertResponse(response);
            },
          });
        },
        error: (error) => {
          this.authService.logout().subscribe({
            next: () => {
              this.handleRevertError(error);
            },
            error: (logoutError) => {
              console.error(
                'Logout error during email revert error:',
                logoutError
              );
              this.handleRevertError(error);
            },
          });
        },
      });
  }

  private handleRevertResponse(response: any): void {
    const location = response.headers.get('Location');
    if (location) {
      window.location.href = location;
    } else {
      try {
        const data =
          typeof response.body === 'string'
            ? JSON.parse(response.body)
            : response.body;
        if (data && data.resetToken) {
          this.router.navigate(['/reset-password'], {
            queryParams: { token: data.resetToken },
          });
        } else if (data && data.error) {
          this.loading = false;
          this.errorMessage = data.error;
        } else {
          this.router.navigate(['/login'], {
            queryParams: { emailReverted: 'true' },
          });
        }
      } catch (e) {
        this.router.navigate(['/login'], {
          queryParams: { emailReverted: 'true' },
        });
      }
    }
  }

  private handleRevertError(error: any): void {
    if (error.status === 302 && error.headers.get('Location')) {
      window.location.href = error.headers.get('Location');
      return;
    }

    this.loading = false;
    if (error.error && typeof error.error === 'string') {
      try {
        const errorData = JSON.parse(error.error);
        this.errorMessage =
          errorData.message ||
          'Failed to revert email change. Please try again.';
      } catch {
        this.errorMessage =
          error.error || 'Failed to revert email change. Please try again.';
      }
    } else if (error.error && error.error.message) {
      this.errorMessage = error.error.message;
    } else {
      this.errorMessage =
        'Failed to revert email change. Please try again or contact support.';
    }

    console.error('Email revert error:', error);
  }
}
